import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Reveal } from '@/components/Reveal';
import { TextReveal } from '@/components/TextReveal';

// NOTE: Generic placeholder booking FAQs — edit freely to match your real policies.
const FAQS = [
  { q: 'How far in advance should I book?', a: 'We recommend booking 2-4 weeks in advance for portrait sessions, and 2-3 months ahead for weddings and large events to secure your preferred date.' },
  { q: 'Do you travel outside the DMV area?', a: 'Yes. While we are based in the DMV (DC, Maryland, Virginia), we are happy to travel for sessions outside the area. Travel fees may apply depending on distance.' },
  { q: 'What is your turnaround time for photos and videos?', a: 'Typically 1-2 weeks for edited photo galleries and 2-4 weeks for edited video content, depending on the scope of the project.' },
  { q: 'Do you require a deposit?', a: 'Yes, a non-refundable deposit is required to secure your booking date. The remaining balance is due before or on the day of the session.' },
  { q: 'Can I reschedule my session?', a: 'Life happens. We allow one complimentary reschedule with at least 48 hours notice, subject to availability.' },
];

export const FAQSection = () => {
  return (
    <section className="bg-[#0A0A0A] border-t border-[hsl(var(--lxra-border))]" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-10 py-20 lg:py-24">
        <Reveal>
          <p className="text-xs tracking-[0.22em] uppercase text-[hsl(var(--lxra-gold))] mb-2 text-center">Good To Know</p>
          <h2 className="font-display text-4xl sm:text-5xl tracking-[0.04em] text-[hsl(var(--lxra-fg))] text-center">
            <TextReveal text="FREQUENTLY ASKED QUESTIONS" />
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-10">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((item, i) => (
              <AccordionItem key={item.question} value={`faq-${i}`} className="border-[hsl(var(--lxra-border))]" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left text-sm sm:text-base text-[hsl(var(--lxra-fg))] hover:text-[hsl(var(--lxra-gold))] hover:no-underline py-5 [&[data-state=open]>svg]:text-[hsl(var(--lxra-gold))]">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-[hsl(var(--lxra-muted))] leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
